import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { RegionService } from '@app/core/services';

@Pipe({
  name: 'ingoFormatCurrency'
})
export class IngoFormatCurrencyPipe implements PipeTransform {

  private currencies = { SE: 'SEK', DK: 'DKK' };
  private locales = { SE: 'sv', DK: 'da' };

  constructor(
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private regionService: RegionService
  ) {}

  transform(value: any, withCurrencyCode: boolean = true): string {

    const countryCode = this.regionService.getCountryCode();

    return withCurrencyCode
      ? this.currencyPipe.transform(value, this.currencies[countryCode], 'code', '1.2-2', this.locales[countryCode])
      : this.decimalPipe.transform(value, '1.2-2', this.locales[countryCode]);
  }
}
